<template>
  <div id="rules_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            規約辦法
            <span
              class="introduction"
              @click="$toExternaLink('https://www.smartdaily.com.tw/rules-of-community/')"
            >{{ $t("General.Instructions") }}</span>
          </div>
          <div class="tip">
            建立相關規約條文辦法
          </div>
        </div>
        <div class="right">
          <el-button
            icon="icon-setting"
            round
            @click="openTypeSetting()"
          >
            設定
          </el-button>
        </div>
      </div>
      <filter-frame
        ref="filter"
        :filter-form="depositFilter"
        @search="search"
        @clear="clearSearch()"
      />
      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <p class="rulesAmount">
            <span :class="rulesAmount >= rulesCapacity ? 'maxAmount' : ''">{{ rulesAmount }}</span>
            <span>{{ ` / ${rulesCapacity}` }}</span>
          </p>
          <el-button
            icon="icon-plus"
            round
            :disabled="addRuleDisabled"
            @click="goRulesCreate"
          >
            新增規約
          </el-button>
        </div>
      </div>
      <el-table
        class="newslist"
        :data="rulesList"
        empty-text="目前無任何規約"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="title"
          label="規約辦法"
          width=""
        >
          <template slot-scope="scope">
            <router-link
              :to="
                {
                  name:'RulesDetail',
                  params:{
                    id: scope.row.statuteId
                  }
                }
              "
              class="rules-title"
            >
              {{ scope.row.title }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="typename"
          label="類型"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.typeName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="create_at"
          label="建立日期"
          width="180"
        />
        <el-table-column
          prop="popular"
          label="人氣"
          width="100"
        />
        <el-table-column
          prop="last_edit_at"
          label="更新時間"
          width="200"
        />
        <el-table-column
          prop="date"
          label="操作"
          width="300"
        >
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'RulesEdit',
                query:{
                  statuteId: scope.row.statuteId
                }
              }"
              class="el-button el-button--default el-button--mini is-plain"
            >
              編輯
            </router-link>
            <el-button
              plain
              size="mini"
              type="danger"
              @click="delRule(scope)"
            >
              刪除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <el-dialog
      id="setting"
      ref="setting"
      title="設定"
      :visible.sync="editConfig"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      :lock-scroll="true"
      center
      @close="goToTop()"
    >
      <div class="basicSetting">
        <div
          v-loading="modalLoading"
          class="block"
        >
          <div class="block_left">
            <h4>規約類型</h4>
          </div>
          <div class="block_right">
            <p class="description normalFont">
              新增類型（最多10個）
            </p>
            <el-row
              class="listHead"
              style="width: 100%"
              align="middle"
              type="flex"
            >
              <el-col class="typeInput">
                <el-input
                  v-model="newType"
                  class="normalInput disabledGrey"
                  style="width: 95%;height:30px;"
                  placeholder="最多15個字"
                  maxlength="15"
                  :disabled="addTypeDisabled"
                  @keyup.enter="addType()"
                />
              </el-col>
              <el-col class="typeAdd">
                <el-button
                  plain
                  size="mini"
                  :disabled="addTypeDisabled"
                  @click="addType()"
                >
                  新增
                </el-button>
              </el-col>
            </el-row>
            <el-row
              style="width: 100%;margin-top:10px"
              align="middle"
              type="flex"
            >
              <el-col class="typeListTitle">
                <p class="normalFont">
                  規約類型列表
                </p>
                <p class="typeAmount">
                  <span :class="typeAmount >= typeCapacity ? 'maxAmount' : ''">{{ typeAmount }}</span>
                  <span>{{ ` / ${typeCapacity}` }}</span>
                </p>
              </el-col>
              <el-col
                class="sortAdjust"
                align="right"
              >
                <el-switch
                  v-show="!sortable"
                  v-model="sortable"
                  active-color="#12B3A4"
                  inactive-color="#dcdfe6"
                  @change="saveOriginalTypeList"
                />
                <p
                  v-show="!sortable"
                  class="arrange"
                >
                  調整排序
                </p>
                <el-button
                  v-show="sortable"
                  plain
                  size="mini"
                  @click="sortable=false;unsortType()"
                >
                  取消
                </el-button>
                <el-button
                  v-show="sortable"
                  plain
                  size="mini"
                  :disabled="sortTypeDisabled"
                  @click="sortable=false;sortType(true)"
                >
                  儲存
                </el-button>
              </el-col>
            </el-row>
            <div class="postalL-list-content">
              <draggable
                v-model="typeList"
                class="draggable"
                :options="{animation:150,handle:''}"
                :disabled="!sortable"
              >
                <transition-group>
                  <el-row
                    v-for="(type,type_index) in typeList"
                    :key="type.Id"
                    align="middle"
                    type="flex"
                    class="normalList"
                    :class="sortable ? 'cursorMove' : '' "
                    :data="typeList"
                  >
                    <el-col
                      v-if="sortable"
                      class="dragHandler"
                    >
                      <i
                        class="el-icon-d-caret"
                        aria-hidden="true"
                      />
                    </el-col>
                    <el-col class="typeName normalSize">
                      <el-input
                        v-model="type.Name"
                        readonly
                        class="noBorder"
                        style="width: 95%;border:none;"
                        maxlength="15"
                      >
                        {{ type.Name }}
                      </el-input>
                    </el-col>
                    <el-col
                      class="operationBtn alignRight"
                      align="right"
                    >
                      <el-button
                        v-if="!sortable"
                        plain
                        size="mini"
                        type="danger"
                        align="right"
                        class="alignRight"
                        :disabled="sortable"
                        @click="deleteType(type.Id,type_index)"
                      >
                        刪除
                      </el-button>
                    </el-col>
                  </el-row>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="handleSave()"
        >完成</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'

import filterFrame from '@/components/FilterFrame'
import draggable from 'vuedraggable'
export default {
  components: {
    'filter-frame': filterFrame,
    draggable,
    TableLoading
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      console.log('vm.$store.state.rules.height', vm.$store.state.rules.height)
      if (vm.$store.state.rules.height !== null) {
        vm.$nextTick(() => {
          document.documentElement.scrollTop = vm.$store.state.rules.height
        })
      }
      if ((from.name === 'RulesEdit' || from.name === 'RulesDetail') && vm.$store.state.rules.height === null) {
        vm.rulesList = []
        vm.getRulesList()
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'RulesDetail' && to.name !== 'RulesEdit') {
      this.$store.commit('recordRulesHeight', null)
    } else {
      this.setHeight()
    }
    next()
  },
  data () {
    return {
      authorization: '',
      filter: {
        title: '',
        typeName: '',
        timeStart: '',
        timeEnd: ''
      },
      scrollEnd: false,
      loading: false,
      offset: 0,
      maxCount: 10,
      depositFilter: [
        {
          label: '標題',
          name: 'title',
          type: 'input',
          rule: [{ min: 0, max: 100, message: '規約標題限定100字元', trigger: 'blur' }]
        },
        {
          label: '規約類型',
          name: 'type',
          type: 'select',
          options: [],
          value: ''
        },
        {
          label: '建立日期',
          name: 'createDate',
          type: 'date'
        }
      ],
      rulesList: [],
      typeList: [],
      editConfig: false,
      sortable: false,
      newType: '',
      rulesCapacity: null,
      typeCapacity: 10,
      originalTypeList: [],
      originalRulesList: [],
      modalLoading: false,
      isBtnClicked: false
    }
  },
  computed: {
    addRuleDisabled () {
      return this.rulesAmount >= this.rulesCapacity
    },
    addTypeDisabled () {
      return this.sortable || this.typeAmount >= this.typeCapacity
    },
    typeAmount () {
      return this.typeList.length
    },
    sortTypeDisabled () {
      if (this.editConfig && this.sortable) {
        for (let i = 0; i < this.typeList.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (this.typeList[i].Id != this.originalTypeList[i].Id) {
            return false
          }
        }
      }
      return true
    },
    rulesAmount () {
      return this.rulesList.length
    }
  },
  mounted () {
    this.authorization = this.$getCookie('comLoginToken').replace('token=', '')
    this.getRulesList()
    this.getRulesAmount()
    this.getTypeList().then(res => { this.giveFilterTypeList() })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    // 查詢
    search (searchValue) {
      console.log(searchValue)
      this.filter = {
        // eslint-disable-next-line eqeqeq
        title: searchValue.title == undefined ? '' : searchValue.title,
        // eslint-disable-next-line eqeqeq
        typeName: searchValue.type == undefined ? '' : searchValue.type,
        // eslint-disable-next-line eqeqeq
        timeStart: searchValue.createDate == undefined ? '' : searchValue.createDate[0],
        // eslint-disable-next-line eqeqeq
        timeEnd: searchValue.createDate == undefined ? '' : searchValue.createDate[1]
      }

      // eslint-disable-next-line eqeqeq
      if (this.rulesList.length != this.originalRulesList.length) {
        this.rulesList = this.originalRulesList
      }

      if (this.filter.title) {
        this.rulesList = filterTitle(this.filter, this.rulesList)
      }

      if (this.filter.typeName) {
        this.rulesList = filterTypeName(this.filter, this.rulesList)
      }

      if (this.filter.timeStart) {
        this.rulesList = filterTime(this.filter, this.rulesList)
      }

      if (!this.filter.title && !this.filter.typeName && !this.filter.timeStart) {
        this.rulesList = this.originalRulesList
      }

      function filterTitle (filter, data) {
        const result = data.filter(item => {
          return item.title.indexOf(filter.title) >= 0
        })
        return result
      }

      function filterTypeName (filter, data) {
        const result = data.filter(item => {
          return item.typeName.indexOf(filter.typeName) >= 0
        })
        return result
      }

      function filterTime (filter, data) {
        const timeStart = Date.parse(filter.timeStart)
        const timeEnd = Date.parse(filter.timeEnd)
        const result = data.filter(item => {
          const createDate = Date.parse(item.create_at)
          return createDate >= timeStart && createDate <= timeEnd
        })
        return result
      }
    },
    // 清除條件
    clearSearch () {
      this.filter = {
        title: '',
        type: '',
        start: '',
        due: ''
      }
      this.rulesList = []
      this.loading = true
      setTimeout(() => {
        this.rulesList = this.originalRulesList
        this.loading = false
      }, 1000)
    },
    getRulesAmount () {
      axios(`${process.env.VUE_APP_MAPI_URL}/Statute/StatuteAmountOfCapacity`, {
        method: 'GET',
        headers: { Authorization: this.authorization }
      }).then(res => {
        this.rulesCapacity = res.data.Data.Capacity
      }).catch(error => {
        console.log(error)
      })
    },
    // 取得規約列表
    getRulesList () {
      const data = {}
      this.loading = true
      setTimeout(() => {
        axios(`${process.env.VUE_APP_MAPI_URL}/Statute/List`, {
          method: 'GET',
          params: data,
          headers: { Authorization: this.authorization }
        }).then(res => {
          console.log(res.data.Data.StatuteList)
          const resData = res.data.Data.StatuteList
          for (let i = 0; i < resData.length; i++) {
            resData[i].create_at = resData[i].create_at.replace(/\//g, '-').slice(0, 10)
            if (resData[i].last_edit_at) {
              resData[i].last_edit_at = resData[i].last_edit_at.replace(/\//g, '-').slice(0, -3)
            } else {
              resData[i].last_edit_at = '-'
            }
            this.rulesList.push(resData[i])
          }
          this.loading = false
          this.saveOriginalRulesList()
        }).catch(error => {
          console.log(error)
        })
      }, 1000)
    },
    // 刪除規約
    delRule (row_data) {
      const vm = this
      console.log(row_data)
      vm.$confirm('規約刪除後將無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        axios(`${process.env.VUE_APP_MAPI_URL}/Statute/Delete`, {
          method: 'DElETE',
          data: { Id: row_data.row.statuteId },
          headers: { Authorization: vm.authorization }
        }).then(res => {
          vm.rulesList.splice(row_data.$index, 1)
          vm.saveOriginalRulesList()
          vm.$message({
            type: 'success',
            message: '刪除規約成功'
          })
        }).catch(err => {
          console.log(err)
          vm.$message({
            message: '刪除規約失敗',
            type: 'error'
          })
        })
      }).catch(() => {
        vm.$message({
          message: '取消刪除',
          type: 'info'
        })
      })
    },
    // 取得規約類別
    getTypeList () {
      this.modalLoading = true
      return new Promise((resolve, reject) => {
        axios(`${process.env.VUE_APP_MAPI_URL}/CustomType/List`, {
          method: 'GET',
          headers: { Authorization: this.authorization },
          params: { CustomType: 'StatuteType' }
        }).then(res => {
          this.modalLoading = false
          this.typeList = res.data.Data.List
          console.log(this.typeList)
          resolve(res.data.Data.List)
        }).catch(error => {
          console.log(error)
          reject(new Error('取得規約類別失敗'))
        })
      })
    },
    giveFilterTypeList () {
      console.log(this.depositFilter)
      this.depositFilter[1].options = []
      this.depositFilter[1].options.push({ label: '請選擇', value: '' })
      for (const item of this.typeList) {
        const obj = {}
        obj.label = item.Name
        obj.value = item.Name
        this.depositFilter[1].options.push(obj)
      }
    },
    openTypeSetting () {
      this.editConfig = true
      this.getTypeList()
      this.saveOriginalTypeList()
    },
    // 新增規約類別
    addType () {
      if (this.isBtnClicked) return
      this.isBtnClicked = true
      const specialCharRegEX = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g
      if (specialCharRegEX.test(this.newType)) {
        this.$message({
          message: '新增類型失敗，類型名稱中不可有空格、特殊符號，請再試一次。',
          type: 'error'
        })
        setTimeout(() => {
          this.isBtnClicked = false
        }, 3000)
        return false
      }
      if (this.newType) {
        for (const item of this.typeList) {
          // eslint-disable-next-line eqeqeq
          if (this.newType == item.Name) {
            this.$message({
              message: '此類別已存在',
              type: 'warning'
            })
            setTimeout(() => {
              this.isBtnClicked = false
            }, 3000)
            return false
          }
        }
        const sendData = {
          CustomType: 'StatuteType',
          Name: this.newType
        }
        axios(`${process.env.VUE_APP_MAPI_URL}/CustomType/Create`, {
          method: 'PUT',
          headers: { Authorization: this.authorization },
          data: sendData
        }).then(res => {
          this.$message({
            message: '新增類別成功',
            type: 'success'
          })
          const newData = {
            Id: res.data.Data.Id,
            Name: this.newType,
            Value: res.data.Data.Id
          }
          this.typeList.push(newData)
          this.newType = ''
          setTimeout(() => {
            this.isBtnClicked = false
          }, 800)
          this.sortType(false)
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '新增類別失敗',
            type: 'error'
          })
          setTimeout(() => {
            this.isBtnClicked = false
          }, 800)
        })
      } else {
        this.$message({
          message: '請輸入類別名稱',
          type: 'warning'
        })
        setTimeout(() => {
          this.isBtnClicked = false
        }, 3000)
      }
    },
    // 刪除規約類別
    deleteType (id, index) {
      const vm = this
      const sendData = {
        CustomType: 'StatuteType',
        Ids: [id]
      }
      this.$confirm('類型刪除後將無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(function () {
        axios(`${process.env.VUE_APP_MAPI_URL}/CustomType/Disable`, {
          method: 'PUT',
          headers: { Authorization: vm.authorization },
          data: sendData
        }).then(res => {
          vm.$message({
            message: '刪除類別成功',
            type: 'success'
          })
          vm.typeList.splice(index, 1)
        }).catch(err => {
          if (err.response.data.ErrorMessage.Code === 400002) {
            vm.$message({
              message: err.response.data.ErrorMessage.Description,
              type: 'warning'
            })
            return
          }
          vm.$message({
            message: '刪除類別失敗',
            type: 'error'
          })
        })
      }).catch(e => {})
    },
    // 排序規約類別
    sortType (ifMsg) {
      const sortList = this.typeList.map(function (item, index) {
        return { Id: item.Id, Sort: index + 1 }
      })
      const sendData = {
        CustomType: 'StatuteType',
        ChangeSortList: sortList
      }
      axios(`${process.env.VUE_APP_MAPI_URL}/CustomType/ChangeSort`, {
        method: 'PUT',
        headers: { Authorization: this.authorization },
        data: sendData
      }).then(res => {
        console.log(res)
        if (ifMsg) {
          this.$message({
            message: '排序類別成功',
            type: 'success'
          })
        }
      }).catch(() => {
        if (ifMsg) {
          this.$message({
            message: '排序類別失敗',
            type: 'error'
          })
        }
      })
    },
    // 取消排序規約類別
    unsortType () {
      this.typeList = this.originalTypeList
    },
    // 控制完成按鈕
    handleSave () {
      let ifSame = true
      if (this.typeList.length === this.originalTypeList.length) {
        for (let i = 0; i < this.typeList.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (this.typeList[i].Id != this.originalTypeList[i].Id) {
            ifSame = false
            break
          }
        }
      } else {
        ifSame = false
      }
      console.log(ifSame)
      if (!ifSame && !this.sortable) {
        this.sortType(false)
        this.giveFilterTypeList()
      }
      this.newType = ''
      this.sortable = false
      this.editConfig = false
    },
    saveOriginalTypeList () {
      this.originalTypeList = _cloneDeep(this.typeList)
      console.log('save type')
    },
    saveOriginalRulesList () {
      this.originalRulesList = _cloneDeep(this.rulesList)
      console.log('save rulesList')
    },
    goToTop () {
      document.getElementById('setting').scrollTop = 0
    },
    goRulesCreate () {
      this.$store.commit('recordRulesHeight', document.documentElement.scrollTop)
      this.$router.push({ name: 'RulesEdit' })
    },
    setHeight () {
      this.$store.commit('recordRulesHeight', document.documentElement.scrollTop)
    }
  }
}
</script>

<style lang="sass" scoped>
#rules_main
  +mainLayer
  text-align: center
  padding: 50px 0 10px
  height: 100%
  ::v-deep .el-dialog__wrapper
    overflow: hidden
  ::v-deep .el-dialog
    +basicDialog
    overflow: auto
    max-height: 80%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 10px 0
      .right
        display: flex
        justify-content: flex-end
        align-items: center
        .rulesAmount
          margin-right: 20px
          font-size: 20px
          .maxAmount
            color: $dangerColor
    .newslist
      font-size: 15px
      .cell
        +NewsStatusTag
      .rules-title
        cursor: pointer
        color: $mainColorDark
        text-decoration: underline
      ::v-deep .el-table
        +basicTable
        &__body a.el-button--default.is-plain
          color: #333

.basicSetting
  width: 100%
  .block
    display: flex
    flex-wrap: wrap
    &:not(:first-child)
      margin-top: 15px
    .block_left
      width: 20%
    .block_right
      display: flex
      flex-wrap: wrap
      width: 80%
      .description
        width: 100%
      .typeListTitle
        display: flex
        justify-content: flex-start
        align-items: center
      .maxAmount
        color: $dangerColor
      .normalFont
        font-size: 15px
        color: #333
        margin-right: 20px
        line-height: 30px
      .normalFont  ::v-deep .el-input__inner
        height: 30px !important
        font-size: 15px !important
      .normalSize  ::v-deep .el-input__inner
       font-size: 15px !important
  .down
    border-top: none
.postalL-list-content
  color: #606266
  font-size: 15px
  width: 100%
  .el-row
    margin: 5px 0
    // padding: 12px 0
    border: solid 1px #ccc
    border-radius: 5px
    text-align: center
    background-color: rgba(255,255,255,1)
    &.listHead
      font-weight: bold
      color: #909399
    &.sortable-ghost
      opacity: 0
    &.sortable-drag
    .dragHandler
      flex-basis: 50px
      text-align: right
      i
        font-size: 15px
        color: #fff
        background-color: #41A07D
        border-radius: 50%
        padding: 3px
    .indexNum
      flex-basis: 80px
    .typeName
      flex: 1
      text-align: left
      word-break: break-word
    .operationBtn
      flex-basis: 170px
      text-align: left
el-dialog
    min-width: 750px
.noBorder ::v-deep .el-input__inner
  border: none !important
.noFocusEffect
    color: #666
    border-color: #ccc
    background-color: #FFFFFF
    &:hover
      color: $mainColor
      border-color: #c6e2d8
      background-color: #ecf5f2
.normalInput  ::v-deep .el-input__inner
  height: 30px !important
  font-size: 15px !important
.alignRight
  text-align: right !important
  margin-right: 10px
.el-input__inner
  font-size: 15px !important
.arrange
  float: right
  margin-top: 3px
  padding-left: 10px
.disabledGrey ::v-deep [disabled="disabled"]
  background-color:$bgDark3 !important
.cursorMove
  cursor: move
  .normalList,.typeName,.operationBtn,.noBorder, ::v-deep .el-input__inner,&.sortable-chosen,&.sortable-ghost
    cursor: move
.sortable-chosen, .sortable-ghost
  cursor: move !important
</style>
